module.exports = "/_next/static/images/hero-large-655455c3cff711c12a6e53dbd1346ed2.png";